export default "__VITE_ASSET__BKdEYYEi__"